import clsx from "clsx";
import type { PropsWithChildren } from "react";

export type FormSectionProps = {
	title?: string;
	className?: string;
};

export const FormSectionGroup: React.FC<PropsWithChildren> = ({ children }) => (
	<div className="flex flex-col gap-6">{children}</div>
);

const FormSection: React.FC<PropsWithChildren<FormSectionProps>> = ({ title, children,className }) => (
	<section className={clsx("flex flex-col gap-1 border-b pb-6 last:border-0 sm:flex-row sm:justify-between sm:gap-4", className)}>
		{title && (
			<div className="pt-1 text-xs font-semibold leading-normal text-gray-400 sm:w-32 sm:min-w-32">
				{title}
			</div>
		)}
		<div className="grow pt-1">{children}</div>
	</section>
);

export default FormSection;
